// extracted by mini-css-extract-plugin
export default {"colLeft":"Statistics_colLeft__kkQsa","colRight":"Statistics_colRight__fp4wE","row":"Statistics_row__zt4W4","col":"Statistics_col__BRP2z"};